export const en = {
    'home-screen-title': 'Main',
    'create-call': 'Create call',
    'home-screen-sub-title': 'Calls',
    'create-call-button': 'Create call outside of meeting',
    'create-call-button-short': 'Create call',
};
